{
  "colorSwatchPicker": "Цветови мостри",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Изберете предмет",
  "tableResizer": "Преоразмерител"
}
